import { initializeApp, FirebaseApp } from 'firebase/app';
import { initializeFirestore, Firestore, persistentLocalCache, persistentSingleTabManager, memoryLocalCache } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';

// Note: We're using process.env instead of import.meta.env for TypeScript compatibility
// This requires proper configuration in vite.config.ts to expose these environment variables
// Get Firebase config from environment variables
const getFirebaseConfig = () => {
  try {
    // Check if environment variables are available
    if (process.env.VITE_FIREBASE_API_KEY) {
      return {
        apiKey: process.env.VITE_FIREBASE_API_KEY,
        authDomain: process.env.VITE_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.VITE_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VITE_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.VITE_FIREBASE_APP_ID
      };
    }
    
    // If environment variables are not available, throw an error
    throw new Error('Firebase konfigürasyon bilgileri bulunamadı. Lütfen .env dosyanızı kontrol edin.');
  } catch (error) {
    console.error('Firebase konfigürasyonu yüklenirken hata:', error);
    throw new Error('Firebase konfigürasyonu yüklenemedi');
  }
};

let app: FirebaseApp | null = null;
let db: Firestore | null = null;
let auth: Auth | null = null;

try {
  // Initialize Firebase with the config
  const firebaseConfig = getFirebaseConfig();
  
  app = initializeApp(firebaseConfig);
  
  // Initialize Firestore with persistent local cache (single-tab mode)
  // This replaces the deprecated enableIndexedDbPersistence approach
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentSingleTabManager(undefined)
    })
  });
  
  console.log('Firestore persistence etkinleştirildi (tek sekme modu)');
  
  // Initialize Authentication
  auth = getAuth(app);
} catch (error) {
  console.error('Firebase başlatılırken kritik hata:', error);
  
  // Fallback: Try to initialize without persistence if the above fails
  if (app && !db) {
    try {
      console.warn('Persistence ile başlatma başarısız, hafıza cache ile deneniyor...');
      db = initializeFirestore(app, {
        localCache: memoryLocalCache() // Use memory cache as fallback
      });
      console.log('Firestore hafıza cache ile başlatıldı');
    } catch (fallbackError) {
      console.error('Firestore hafıza cache ile bile başlatılamadı:', fallbackError);
    }
  }
}

// Get user ID from authenticated user
export const getUserId = (): string => {
  if (!auth) {
    throw new Error('Auth is not initialized');
  }
  
  if (!auth.currentUser) {
    throw new Error('User is not authenticated');
  }
  
  return auth.currentUser.uid;
};

// Check if user is authenticated
export const isUserAuthenticated = (): boolean => {
  return !!(auth && auth.currentUser);
};

export { app, db, auth }; 